module.exports = __webpack_public_path__ + "static/media/phone.4ee35c63.svg";